<simple-modal
  [visible]="visible"
  title="Internal error"
  subtitle="Something went wrong"
>
  <div class="something-went-wrong-modal">
    <div class="modal-text">Please report this issue</div>
    <ros-button
      class="modal-button"
      title="Got it"
      size="Large"
      (onClick)="closeModal()"
    ></ros-button>
  </div>
</simple-modal>
